module.exports = __webpack_public_path__ + "img/914ad91.jpg";